import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { handleGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Get session_id from URL hash
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id in URL');
        navigate('/auth', { replace: true });
        return;
      }

      try {
        await handleGoogleCallback(sessionId);
        // Clear hash and redirect to home using React Router
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Google auth callback error:', error);
        navigate('/auth', { replace: true });
      }
    };

    processCallback();
  }, [handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-fgs-bg">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-fgs-primary animate-spin mx-auto mb-4" />
        <p className="text-fgs-text-muted">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
